import { Type } from 'class-transformer';
import { IsNotEmptyObject, IsOptional, IsString, ValidateNested } from 'class-validator';

import { NotificationSubscriptionsDto } from '../notifications';

export class UserPreferencesDto {
  @IsOptional()
  @IsString()
  locale?: string;

  @IsOptional()
  @IsString()
  theme?: string;

  @IsOptional()
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => NotificationSubscriptionsDto)
  subscriptions?: NotificationSubscriptionsDto;
}
